import _ from "lodash";
import pDebounce from 'p-debounce';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import { Actions as XERO_ACTIONS } from './store/xeroActions';
import { ArrowLeftIcon, ChevronDownIcon, Cog8ToothIcon, ExclamationTriangleIcon, MinusIcon, UserGroupIcon } from "@heroicons/react/20/solid";
import xeroLogo from "./assets/xero-logo.svg";
import { getCurrency } from "../../common/validation/Validators";

const XeroSettings = ({
  disabled,
  contactOptions,
  getContacts,
  connected,
  tenants,
  tenant,
  connectLink,
  accounts,
  taxNames,
  taxRates,
  allowances,
  jurisdiction,
  departments,
  trackingCategories,
  saveXeroSettings,
  getXeroContacts,
  disconnectOrganisation,
  saving,
  updateTenant,
  connectXero,
  settings
}) => {
  const [reviewConnections, setReviewConnection] = useState(false)
  const [expand, setExpand] = useState(false)
  const [newTenant, setNewTenant] = useState()
  const [xeroSettings, setSettings] = useState({})

  useEffect(() => {
    if (!connected) return
    if (!tenant) return
    setNewTenant(tenant)
    setSettings({ ...settings })
  }, [connected, tenant, settings])

  const updateField = (field, value) => {
    if (field.includes('[')) field = _.setWith({}, field, value, Object)

    setSettings({ ...(_.merge(xeroSettings, { ...(typeof field == 'object' ? field : { [field]: value }) })) })
  }

  const selectedTenant = tenants?.find(item => item.value == newTenant)

  const contactOptionsPromise = pDebounce((inputValue) => getXeroContacts(inputValue), 300);


  // const departments = []

  // const trackingOptionOptions =
  //   settings.trackingCategories &&
  //   _.find(settings.trackingCategories, { TrackingCategoryID: trackingCategory.value }).Options.map((category) => ({
  //     label: category.Name,
  //     value: category.TrackingOptionID,
  //   }))

  if (!connected) return (
    <div className="col-sm-12 integration-row">
      <div className="col-sm-3">
        <div className="pull-left">
          <img src={xeroLogo} width="40px" />
          <span style={{ paddingLeft: 20, fontSize: 16 }}>Xero</span>
        </div>
      </div>
      <div className="col-sm-9">
        <button className="btn btn-primary pull-right" onClick={() => connectXero()}>
          Connect
        </button>
      </div>
    </div>
  )

  const employeeContact = {
    label: "To Each Individual Employee",
    value: "employee",
  }

  const contactsWithEmployee = contactOptions && [...contactOptions]
  contactsWithEmployee && contactsWithEmployee.unshift(employeeContact)

  return (
    <div className={`${expand ? "tr-gray" : ""} col-sm-12 integration-row`}>
      <div className="col-sm-3">
        <div className="pull-left">
          <img src={xeroLogo} width="40px" />
          <span style={{ paddingLeft: 20, fontSize: 16 }}>Xero</span>
        </div>
      </div>
      <div className="col-sm-9">
        <div className="btn btn-default pull-right" style={{ paddingRight: 6 }} onClick={() => setExpand(!expand)}>
          <Cog8ToothIcon style={{ height: "1.5em", float: "left" }} />
          <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Settings</div>
          <ChevronDownIcon
            style={{
              height: "1.5em",
              float: "left",
              transform: expand ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease-in-out",
            }}
          />
        </div>
        <div className="btn btn-default pull-right" style={{ marginRight: 10 }}>
          <div style={{ float: "left", marginLeft: 5, marginRight: 5 }}>Connected</div>
        </div>
      </div>
      <div className="col-sm-12">
        {expand && (
          <>
            {reviewConnections ? (
              <>

                <div style={{ marginTop: 15 }}>
                  <div className="pull-left">
                    <h5 >Connected Organisations</h5>
                  </div>

                  <button
                    className="btn btn-primary pull-right"
                    onClick={() => { window.location.href = connectLink }}
                  >
                    Connect Another Organisation
                  </button>
                </div>

                <div className="row">
                  <div className="col-sm-6" style={{ marginTop: 15 }}>
                    {tenants?.map?.((o) => (
                      <div className="col-sm-12 organisation-row">
                        <div className="pull-left" style={{ padding: "6px 12px" }}>
                          {o.label}
                        </div>
                        <button
                          className="btn btn-default pull-right"
                          onClick={(e) => {
                            e.preventDefault()
                            disconnectOrganisation(o.connectionId)
                          }}
                        >
                          <MinusIcon style={{ height: "1.5em", float: "left" }} />
                          <div style={{ float: "left", marginLeft: 5 }}>Disconnect</div>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

                <button
                  style={{ marginTop: 10 }}
                  className='btn btn-default'
                  onClick={() => {
                    setReviewConnection(false)
                  }}
                >
                  <ArrowLeftIcon style={{ height: "1.5em", float: "left" }} />
                  <div style={{ float: "left", marginLeft: 5 }}>Back to Settings</div>
                </button>
              </>
            ) : (
              <>
                <div className="row" style={{ paddingBottom: 0 }}>
                  <h5>Organisation</h5>

                  <div className="col-sm-12" style={{ marginTop: 10 }}>
                    <div className="col-sm-4">
                      <Select
                        value={tenants?.find(item => item.value == newTenant)}
                        onChange={(selectedOption) => {
                          setNewTenant(selectedOption.value)
                        }}
                        isDisabled={disabled}
                        options={tenants}
                      />
                    </div>

                    <div className="col-sm-4">
                      {newTenant != tenant ?
                        <button
                          className="btn btn-success"
                          onClick={(e) => {
                            e.preventDefault()
                            updateTenant(newTenant)
                          }}
                        >
                          {saving ? "Updating Xero Organisation..." : "Update Xero Organisation"}
                        </button>
                        : null}
                    </div>

                    <div className="col-sm-4">
                      <button
                        className="btn btn-default pull-right"
                        onClick={() => {
                          setReviewConnection(true)
                        }}
                      >
                        <UserGroupIcon style={{ height: "1.5em", float: "left" }} />
                        <div style={{ float: "left", marginLeft: 5 }}>Review Organisations</div>
                      </button>
                    </div>

                  </div>
                </div>
                {(tenant && selectedTenant?.hasCurrency) ? <>
                  <div className="row">
                    <h5>Basic Salaries </h5>

                    <div className="col-sm-6" style={{ marginTop: "15px" }}>
                      <label>Account Code</label>

                      <Select
                        value={xeroSettings?.basicAccountCode}
                        isDisabled={disabled}
                        onChange={(selectedOption) => {
                          updateField('basicAccountCode', selectedOption)
                        }}
                        options={accounts}
                      />
                      <div className="clearfix" />
                    </div>

                    <div className="col-sm-6" style={{ marginTop: "15px" }}>
                      <label>Payable To</label>

                      <AsyncSelect
                        value={xeroSettings?.basicPayableTo}
                        isDisabled={disabled}
                        onChange={(selectedOption) => {
                          updateField(`basicPayableTo`, selectedOption)
                        }}

                        defaultOptions={[employeeContact]}
                        placeholder="Search &amp; Select a contact..."
                        loadOptions={contactOptionsPromise}
                      />
                      <div className="clearfix" />
                    </div>
                  </div>

                  <div className="row">
                    <h5>Allowances &amp; Overtime</h5>

                    <div className="col-sm-6" style={{ marginTop: "15px" }}>
                      <label>Overtime Account Code</label>

                      <Select
                        value={xeroSettings?.overtimeAccountCode}
                        isDisabled={disabled}
                        onChange={(selectedOption) => {
                          updateField(`overtimeAccountCode`, selectedOption)
                        }}
                        options={accounts}
                      />
                      <div className="clearfix" />
                    </div>

                    {allowances?.map((allowance) => (
                      <div className="col-sm-6" style={{ marginTop: "15px" }} key={allowance.id}>
                        <label>{allowance.allowanceName || allowance.name} Account Code</label>

                        <Select
                          value={xeroSettings?.allowances?.[allowance.id]}
                          isDisabled={disabled}
                          onChange={(selectedOption) => {
                            updateField(`allowances[${allowances.id}]`, selectedOption)
                          }}
                          options={accounts}
                        />
                        <div className="clearfix" />
                      </div>
                    ))}
                  </div>

                  {/* {xeroSettings?.departments &&
                  <div className="row">
                    <h5>Departments</h5>

                    {trackingCategoryOptions &&
                      <div className="col-sm-12 pl-0" style={{ marginTop: "15px" }}>
                        <label>Tracking Category</label>

                        <Select
                          value={xeroSettings?.trackingCategory}
                          onChange={(selectedOption) => {

                            const xeroSettings = {
                              ...settings.settings,
                              trackingCategory: selectedOption,
                            }

                            const updatedSettings = {
                              ...settings,
                              settings: xeroSettings,
                            }

                            setSettings(updatedSettings)
                          }}
                          options={trackingCategoryOptions}
                        />
                        <div className="clearfix" />
                      </div>
                    }

                    {xeroSettings?.departments?.map((department) => (
                      <>
                        <div className="col-sm-6" style={{ marginTop: "15px" }} key={department.id}>
                          <label>{department.name} Account Code</label>

                          <Select
                            value={xeroSettings?.departments?.[department.id]?.account}
                            isDisabled={disabled}
                            onChange={(selectedOption) => {
                              const departments = { ...settings.settings.departments }

                              if (!departments[department.id]) {
                                departments[department.id] = {}
                              }

                              departments[department.id].account = selectedOption

                              const xeroSettings = {
                                ...settings.settings,
                                departments: departments,
                              }

                              const updatedSettings = {
                                ...settings,
                                settings: xeroSettings,
                              }

                              setSettings(updatedSettings)
                            }}
                            options={accounts}
                          />
                          <div className="clearfix" />
                        </div>
                        {trackingOptionOptions &&
                          <div className="col-sm-6" style={{ marginTop: "15px" }}>
                            <label>{department.name} Tracking Option</label>

                            <Select
                              value={xeroSettings?.departments?.[department.id]?.trackingCode}
                              isDisabled={disabled}
                              onChange={(selectedOption) => {
                                const departments = { ...settings.settings.departments }

                                if (!departments[department.id]) {
                                  departments[department.id] = {}
                                }

                                departments[department.id].trackingCode = selectedOption

                                const xeroSettings = {
                                  ...settings.settings,
                                  departments: departments,
                                }

                                const updatedSettings = {
                                  ...settings,
                                  settings: xeroSettings,
                                }

                                setSettings(updatedSettings)
                              }}
                              options={trackingOptionOptions}
                            />
                            <div className="clearfix" />
                          </div>
                        }
                      </>
                    ))}
                  </div>
                } */}

                  <div className="row">
                    <h5>Taxes</h5>

                    {taxNames?.map((taxName) => (
                      <>
                        <div className="col-sm-6" style={{ marginTop: "15px" }} key={taxName}>
                          <label>{taxName} Account Code</label>

                          <Select
                            value={xeroSettings?.taxes?.[taxName]?.account}
                            isDisabled={disabled}
                            onChange={(selectedOption) => {
                              updateField(`taxes[${taxName}][account]`, selectedOption)
                            }}
                            options={accounts}
                          />
                          <div className="clearfix" />
                        </div>
                        <div className="col-sm-6" style={{ marginTop: "15px" }}>
                          <label>{taxName} Payable To</label>

                          <AsyncSelect
                            value={xeroSettings?.taxes?.[taxName]?.payable}
                            isDisabled={disabled}
                            onChange={(selectedOption) => {
                              updateField(`taxes[${taxName}][payable]`, selectedOption)
                            }}
                            placeholder="Search & Select a contact..."
                            loadOptions={contactOptionsPromise}

                          />
                          <div className="clearfix" />
                        </div>
                      </>
                    ))}
                  </div>
                  <div className="pull-right">
                    {!disabled && (
                      <button
                        className="btn btn-success"
                        disabled={saving}
                        onClick={(e) => {
                          e.preventDefault()
                          if (saving) return
                          saveXeroSettings(xeroSettings)
                        }}
                      >
                        {saving ? "Saving..." : "Save"}
                      </button>
                    )}

                    {/* {!disabled && departments.length > 0 && (
                    <div className="col-sm-3" style={{ marginTop: "15px" }}>
                      <label>
                        <input type="checkbox" name="departmentGroup" checked={checkGroupBy} onClick={() => setcheckGroupBy(!checkGroupBy)} />
                        Group by Department
                      </label>
                      <label style={{ marginTop: 15 }}>Choose Department</label>
                      <select
                        className="form-control"
                        // onClick={() => setDepartmentFilter(!checkGroupBy)}
                        onChange={(e) => {
                          setDepartmentFilter(e.target.value)
                        }}
                      >
                        <option>All</option>
                        {departments.map((department) => {
                          return (
                            <option key={department.id} value={department.id}>
                              {department.name}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  )} */}
                  </div>
                </> : null}
                {(selectedTenant && !selectedTenant?.hasCurrency) ? <>
                  <div style={{ display: 'flex', alignItems: 'center', placeContent: "center", padding: '3rem' }}>
                    <div className="item item-circle bg-danger" style={{ position: 'relative', height: '8rem', width: '8rem' }} >
                      <ExclamationTriangleIcon style={{ position: 'absolute', height: '6rem', color: 'white', right: '1rem', top: '1rem' }} />
                    </div>
                  </div>
                  <div className="col-xs-12" style={{ textAlign: 'center' }}>
                    <h4>{selectedTenant?.label} does not support <span style={{ color: '#ea611c', fontWeight: 'bolder' }}>{getCurrency(jurisdiction)}</span> transactions</h4>
                  </div>
                </> : null}
              </>
            )}
          </>
        )}
      </div>
      <div className="clearfix" />
    </div>
  )
}

const mapStateToProps = (state) => {
  const { xero } = { ...state.integration?.accounting }
  const { tenant, tenants, savingData, connectLink, accounts, contacts: contactOptions, trackingCategories, settings, taxNames, taxRates } = { ...xero }
  const { allowances, departments, jurisdiction } = { ...state.company?.settings }
  return {
    connected: tenants?.length > 0,
    tenants,
    saving: savingData,
    tenant,
    contactOptions,
    settings,
    accounts,
    taxNames,
    taxRates,
    trackingCategories,
    connectLink,
    disabled: state?.permissions?.my?.permissions?.settings == "Read",
    allowances,
    jurisdiction,
    departments
  }
}

const mapDispatchToProps = (dispatch) => ({
  getContacts: (input) => dispatch(XERO_ACTIONS.getContactOptions(input)),
  disconnectOrganisation: (input) => dispatch(XERO_ACTIONS.disconnectOrganisation(input)),
  updateTenant: (input) => dispatch(XERO_ACTIONS.updateTenant(input)),
  saveXeroSettings: (input) => dispatch(XERO_ACTIONS.saveXeroSettings(input)),
  getXeroContacts: XERO_ACTIONS.getXeroContacts,
  connectXero: () => dispatch(XERO_ACTIONS.connectXero()),
})

export default connect(mapStateToProps, mapDispatchToProps)(XeroSettings)
